export default function retry(func: Function, interval: number = 1000): Function {
  const intervalId = setInterval(func, interval)
  return () => {
    clearInterval(intervalId)
  }
}
